// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
import type { UserManagerSettings } from "oidc-client-ts";
import type { RuntimeAuthConfig } from "./config";

export function buildOidcConfig(
  cfg: RuntimeAuthConfig,
  { origin }: { readonly origin: string },
): UserManagerSettings {
  // oidc-client-ts requires snake_case keys; ignore Biome's camelCase rule here.
  return {
    authority: cfg.issuer,
    // biome-ignore lint/style/useNamingConvention: oidc-client-ts API
    client_id: cfg.clientId,
    // biome-ignore lint/style/useNamingConvention: oidc-client-ts API
    redirect_uri: cfg.redirectUri ?? `${origin}/auth/callback`,
    // biome-ignore lint/style/useNamingConvention: oidc-client-ts API
    response_type: "code",
    scope: cfg.scopes.join(" "),
    automaticSilentRenew: true,
    loadUserInfo: true,
  };
}

export function hasScope(profile: { scope?: string } | undefined | null, scope: string): boolean {
  if (!profile?.scope) return false;
  return profile.scope.split(/\s+/).includes(scope);
}
